
var haiso_targetNode = document.querySelector("cart-items-component");

var observer = new MutationObserver(function(mutations, observer) {
        for (var i = 0; i < mutations.length; i++) {
            console.log(mutations[i].target);
            if (mutations[i].target && mutations[i].target.className == "cart-items-component") {
                if(!document.querySelector("#haisosm")){
                    createCalendar(HaisoJquery);
                }else if(document.querySelector("#haisosm").textContent == ''){
                    createCalendar(HaisoJquery);    
                }             
            }
        }
    });

if (haiso_targetNode) {
  observer.observe(haiso_targetNode, { childList: true, subtree: true,
    attributes: true});
}